import { jsx, jsxs } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { cloneElement, forwardRef } from "react";
import { useSlotProps } from "../../base/index.js";
import { Highlighter as DefaultHighlighter } from "../Highlighter/index.js";
import { detailRowName } from "./classes.js";
import { ColumnDescription } from "./components/ColumnDescription.js";
import { ColumnLabel } from "./components/ColumnLabel.js";
import { Description } from "./components/Description.js";
import { EmptyIcon } from "./components/EmptyIcon.js";
import { IconContainer } from "./components/IconContainer.js";
import { Label } from "./components/Label.js";
import { Root } from "./components/Root.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const defaultHighlight = {
  pattern: "",
  searchIn: "label"
};
const DetailRow = forwardRef(function DetailRow2(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: detailRowName
  });
  const ownerState = { ...props };
  const {
    label,
    description,
    componentsProps,
    testId = `${detailRowName}-root`,
    iconSize,
    noIcon,
    icon,
    highlight = defaultHighlight,
    ...rest
  } = props;
  const utilityClasses = useUtilityClasses(ownerState);
  const rootSlotProps = useSlotProps({
    ownerState,
    externalForwardedProps: rest,
    className: utilityClasses.root,
    elementType: Root,
    externalSlotProps: componentsProps?.root,
    additionalProps: {
      ref,
      "data-testid": testId
    }
  });
  const columnLabelProps = useSlotProps({
    elementType: ColumnLabel,
    externalSlotProps: componentsProps?.columnLabel,
    ownerState,
    className: utilityClasses.columnLabel
  });
  const columnDescriptionProps = useSlotProps({
    elementType: ColumnDescription,
    externalSlotProps: componentsProps?.columnDescription,
    ownerState,
    className: utilityClasses.columnDescription
  });
  const labelProps = useSlotProps({
    elementType: Label,
    externalSlotProps: componentsProps?.label,
    ownerState,
    additionalProps: {
      variant: "body2"
    },
    className: utilityClasses.label
  });
  const descriptionProps = useSlotProps({
    elementType: Description,
    externalSlotProps: componentsProps?.description,
    additionalProps: {
      variant: "body2"
    },
    ownerState,
    className: utilityClasses.description
  });
  const iconProps = useSlotProps({
    elementType: IconContainer,
    externalSlotProps: componentsProps?.icon,
    ownerState,
    className: utilityClasses.icon
  });
  const labelHighlight = highlight.pattern.length > 0 && (highlight?.searchIn === "label" || highlight?.searchIn === "all");
  const descriptionHighlight = highlight.pattern.length > 0 && (highlight?.searchIn === "description" || highlight?.searchIn === "all");
  const Highlighter = highlight.component ?? DefaultHighlighter;
  return /* @__PURE__ */ jsxs(Root, { ...rootSlotProps, "data-tidal": "DetailRow", children: [
    /* @__PURE__ */ jsxs(ColumnLabel, { ...columnLabelProps, children: [
      !noIcon && /* @__PURE__ */ jsx(IconContainer, { ...iconProps, children: cloneElement(icon ?? /* @__PURE__ */ jsx(EmptyIcon, {}), { fontSize: "inherit" }) }),
      /* @__PURE__ */ jsx(Label, { ...labelProps, noWrap: true, children: labelHighlight ? /* @__PURE__ */ jsx(Highlighter, { ...highlight.componentProps, pattern: highlight.pattern, text: label }) : label })
    ] }),
    /* @__PURE__ */ jsx(ColumnDescription, { ...columnDescriptionProps, children: /* @__PURE__ */ jsx(Description, { ...descriptionProps, children: descriptionHighlight ? /* @__PURE__ */ jsx(Highlighter, { ...highlight.componentProps, pattern: highlight.pattern, text: description }) : description }) })
  ] });
});
export {
  DetailRow
};
//# sourceMappingURL=DetailRow.js.map
